/**
 * This file provides the custom settings for ChartJS
 */
let settings = {
    // Pie & Doughnut
    colors: [
        '#0C2340',
        '#80BBBF',
        '#2E7098',
        '#CB4700',
        '#490A71',
        '#0041AC',
        '#000000',
        '#ACC9CD',
        '#1D8035',
        '#005059',
        '#825D02',
        '#AD8C00',
        '#7A2499',
        '#4A1165',
        '#29C5A9',
        '#5677B0',
        '#007A50',
    ],
    // Bar & Grouped Charts
    barColors: [
        '#0C2340',
        '#80BBBF', 
        '#490A71',
        '#008A00', 
        '#CB4700', 
        '#2E7098',
    ],
    // Stacked Bar Charts
    stackedBarColors: [
        '#0C2340',
        '#80BBBF', 
        '#008A00',
        '#490A71', 
        '#CB4700', 
        '#2E7098',
    ],
    // CAGR Charts
    cagrBarColors: [
        '#2E7098',
        '#007780',
        '#80BBBF', 
        '#490A71',
        '#008A00', 
        '#CB4700',
    ],
    // Line Charts
    lineColors: [
        '#2E7098',
        '#008A00',
        '#CB4700',
        '#490A71',
        '#2E7098', 
        '#0041AC',
    ],
    // Line Chart Point Styles
    pointStyles: [
        'circle',
        'rect',
        'triangle',
        'star',
        'rhombus',
        'pentagon',
        'cross',
        'crossRot',
        'rectRot',
        'line',
        'rectRounded',
        'dash',
    ],
    rotation: 0,
    cutout: '50%',
    legendPosition: 'bottom',
    legendAlign: 'start',
    abbreviateNumber: true,
    pointRadius: 5,
    pointBorderWidth: 2,
    cubicInterpolationMode: 'monotone',
    font_family: "'Neue Montreal', sans-serif",
    axisLabelColor: '#555',
};
// Per-chart pie/doughnut color palettes, keyed by CMS chart id. When a chart id is
// listed here its segments use this exact order instead of the shared settings.colors.
// Portfolio page (/portfolio): left "Investment Type" (44210) uses the brand 6-color
// order; right "Sector" (44211) mirrors the HLEND-E palette/order.
let chartColorOverrides = {
    44210: ['#000037', '#D5D5D3', '#1FCBB6', '#B08F63', '#295CEA', '#61CCE2'],
    44211: ['#000037', '#1FCBB6', '#B08F63', '#295CEA', '#61CCE2', '#6F6E6C', '#016966', '#CAF7EC', '#E2CEAF'],
};
/* Setup config data for the charts
 * 'cd' is the JSON config data provided by the Chart class
 * 'pcd' is the prepared config data that is sent to Chart.js
 */
function prep_config(cd) {
    let pcd = {};
    pcd.type = cd.type;
    pcd.type = cd.type === 'bar' && cd.horizontal_bar ? 'bar' : cd.type;
    let monotype = cd.datasets.map(dataset => dataset.type).every(value => value === cd.datasets[0].type);
    
    jq.each(cd.datasets, function(index, value) {
        if (pcd.type === 'bar') {
            // Determine the color setting based on conditions
            let colorSetting = settings['barColors']; // Default color setting
            
            if (cd.stacked === 1) {
                colorSetting = settings['stackedBarColors'];
            } else if (cd.cagr === 1) {
                colorSetting = settings['cagrBarColors'];
            }
        
            // Apply the determined color setting
            cd.datasets[index]['backgroundColor'] = colorSetting[index];
            cd.datasets[index]['hoverBackgroundColor'] = colorSetting[index];
 
            // Revert order so that the first dataset is the first to be drawn (for mixed charts)
            if (!monotype) {
                cd.datasets[index]['order'] = cd.datasets.length - index;
            }
            if (value.type == 'Line') {
                cd.datasets[index]['type'] = 'line';
                cd.datasets[index]['borderColor'] = settings['barColors'][index];
            }
        } else if (pcd.type === 'line') {
            cd.datasets[index]['borderColor'] = settings['lineColors'][index];
            cd.datasets[index]['pointBackgroundColor'] = '#FFFFFF';
            cd.datasets[index]['pointBorderColor'] = settings['lineColors'][index];
            cd.datasets[index]['pointBorderWidth'] = 2;
            cd.datasets[index]['pointStyle'] = settings['pointStyles'][index];
            
            // Prevent colors from changing on hover
            cd.datasets[index]['hoverBorderWidth'] = 2;
            cd.datasets[index]['hoverBackgroundColor'] = '#FFFFFF';
        } else {
            cd.datasets[index]['backgroundColor'] = settings['colors'];
        }
        if (pcd.type === 'pie' || pcd.type === 'doughnut') {
            // Use a per-chart palette when defined, otherwise the shared palette
            let palette = chartColorOverrides[cd.id] || settings['colors'];
            // Set backgroundColor and borderColor for pie chart segments
            cd.datasets[index]['backgroundColor'] = palette;
            cd.datasets[index]['borderColor'] = "#FFFFFF";
            cd.datasets[index]['borderWidth'] = 1;

            // Prevent colors from changing on hover
            cd.datasets[index]['hoverBackgroundColor'] = palette;
            cd.datasets[index]['hoverBorderColor'] = "#FFFFFF";
        }
    });
    
    // Add in the chart data
    pcd.data = {
        labels: cd.labels,
        datasets: cd.datasets
    };
    pcd.labels = cd.labels;
    
    // Global chart options
    let baseOptions = {
        indexAxis: cd.horizontal_bar ? 'y' : 'x',
        spanGaps: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip: {
                enabled: false,
                position: 'average',
                external: externalTooltipHandler,
            }
        },
        rotation: settings.rotation,
        cutout: cd.type === 'doughnut' ? settings.cutout : '0',
        unit: cd.unit,
        custom_unit: cd.custom_unit,
        chart_height: cd.chart_height,
        hide_x_axis_unit: cd.hide_x_axis_unit,
        hide_legend_unit: cd.hide_legend_unit,
        hide_tooltip_unit: cd.hide_tooltip_unit,
        tick_steps: cd.tick_steps,
        extra_tick_space: cd.extra_tick_space,
        segment_text: cd.segment_text,
        horizontal_bar: cd.horizontal_bar
    };
    
    // Default scales options, which may be overridden based on the chart type
    let scalesOptions = {
        x: {
            border: {
                display: false,
                borderColor: 'transparent',
                borderWidth: 0
            },
            ticks: {
                callback: function(value, index, values) {
                    // If a chart is using full month names as labels -
                    // This function will automatically abbreviate it in the x-axis labels
                    const monthAbbreviations = {
                        'January': 'Jan', 'February': 'Feb', 'March': 'Mar', 'April': 'Apr',
                        'May': 'May', 'June': 'Jun', 'July': 'Jul', 'August': 'Aug',
                        'September': 'Sep', 'October': 'Oct', 'November': 'Nov', 'December': 'Dec'
                    };
                    const label = this.getLabelForValue(value);
                    return monthAbbreviations[label] || label;
                },
                font: {
                    family: settings.font_family,
                },
                color: settings.axisLabelColor
            },
        },
        y: {
            beginAtZero: true,
            min: 0,
            ticks: {
                font: {
                    family: settings.font_family
                },
                color: settings.axisLabelColor
            }
        }
    };
    
    // Calculate the maximum value across all datasets for dynamic yAxisMax
    let maxDataValue = Math.max(...pcd.data.datasets.map(dataset => Math.max(...dataset.data)));
    
    // Set tick steps with a default of 50 if none provided
    cd.tick_steps = cd.tick_steps || 50;
    
    // Function to calculate yAxisMax with optional extra space
    const calculateYAxisMax = (maxValue, tickStep, addExtraSpace) => {
        let baseMax = Math.ceil(Number(maxValue) / Number(tickStep)) * Number(tickStep);
        let extraSpaceFactor = 0; // Initialize with no extra space
    
        // Determine extra space factor based on conditions
        if (addExtraSpace) {
            extraSpaceFactor = cd.stacked === 1 ? 3 : 1; // Triple space for stacked if extra space is requested, otherwise just one tickStep
        } else {
            extraSpaceFactor = cd.stacked === 1 ? 2 : 0; // Double space for stacked by default, no extra space otherwise
        }
    
        // Calculate final value by adding the calculated extra space to baseMax
        return baseMax + (Number(tickStep) * extraSpaceFactor);
    };
    
    // Determine if extra space should be added
    let addExtraSpace = cd.extra_tick_space === 1;
    
    // Customize options based on the chart type
    switch (cd.type) {
        case 'line':
            scalesOptions.y.ticks.stepSize = cd.tick_steps;
            scalesOptions.y.max = calculateYAxisMax(maxDataValue, cd.tick_steps, addExtraSpace);
            scalesOptions.x.grid = { display: false };
            cd.datasets.forEach(dataset => {
                dataset.pointHoverRadius = settings.pointRadius; // Prevents point icons from expanding on hover
                dataset.borderWidth = 2; // Set line thickness to 2px
            });
            break;
        case 'bar':
            if (!cd.horizontal_bar) {
                scalesOptions.y.ticks.stepSize = cd.tick_steps;
                scalesOptions.y.max = calculateYAxisMax(maxDataValue, cd.tick_steps, addExtraSpace);
            } else {
                scalesOptions.x.ticks.stepSize = cd.tick_steps;
                scalesOptions.x.max = calculateYAxisMax(maxDataValue, cd.tick_steps, addExtraSpace);
                // Configure the y-axis
                scalesOptions.y = {
                    ticks: {
                        color: settings.axisLabelColor, // Set color for y-axis labels
                        font: {
                            weight: 'bold',
                            family: settings.font_family,
                        },
                    },
                };
                                // Configure the y-axis
                scalesOptions.x = {
                    ticks: {
                        color: settings.axisLabelColor, // Set color for y-axis labels
                        font: {
                            weight: 'bold',
                            family: settings.font_family,
                        },
                    },
                };
            }
            scalesOptions.y.border = {
                display: false,
                borderColor: 'transparent',
                borderWidth: 0
            };
            break;
    }
    
    // Apply specific settings only if it's a horizontal bar chart
    if (cd.horizontal_bar == 1) {
        scalesOptions.x.display = false;
        scalesOptions.y.display = true;
    }
    
    // Merge the scales options into the base options
    baseOptions.scales = scalesOptions;
    
    // Assign the merged options to pcd.options
    pcd.options = baseOptions;
    // Add titles to X and Y scales if provided
    if (cd.x_axis_title) {
        pcd.options.scales.x.title = {
            display: false,
            text: cd.x_axis_title,
            color: settings.axisLabelColor,
            font: {
                family: settings.font_family,
                weight: 'bold'
            }
        }
    }
    if (cd.y_axis_title) {
        pcd.options.scales.y.title = {
            display: true,
            text: cd.y_axis_title,
            color: settings.axisLabelColor,
            font: {
                family: settings.font_family,
                weight: 'bold'
            }
        }
    }
        
    // Legend plugin
    let legend_wrapper_id = `chart-${cd.row_id}-${cd.id}-legend`;
    let legend_wrapper_type = jq('#' + legend_wrapper_id).attr('data-type');
    pcd.options.plugins.legend = {
        display: false,
    }
    if (cd.type == 'pie' || cd.type == 'doughnut') {
        pcd.options.scales.x.display = false;
        pcd.options.scales.y.display = false;
        if (!cd.hide_legend_table) {
            pcd.plugins = [htmlLegendPlugin];
            pcd.options.plugins.htmlLegend = {
                containerID: `chart-${cd.row_id}-${cd.id}-legend`,
                type: legend_wrapper_type,
            }
        }
        pcd.options.plugins.datalabels = {
            display: false, 
        }
    } else if (cd.type == 'bar') {
        pcd.options.scales.x.grid = {
            display: false,
        }
        if (cd.horizontal_bar) {
            pcd.options.plugins.datalabels = {
                display: true, 
                anchor: 'end',
                align: 'end',
                formatter: (value) => `${value}%`,
                color: settings.axisLabelColor,
                font: {
                    family: settings.font_family,
                }
            }
        } else {
            pcd.options.plugins.datalabels = {
                display: false, 
            }
        }
        if (pcd.data.datasets.length > 1 && !cd.cagr && !cd.hide_legend_table) {
            pcd.plugins = [htmlLegendPlugin];
            pcd.options.plugins.htmlLegend = {
                containerID: `chart-${cd.row_id}-${cd.id}-legend`,
                type: legend_wrapper_type
            }
        }
        if (cd.cagr) {
            // Set the bar data to the second dataset to apper behind the cagr line
            pcd.data.datasets[1] = pcd.data.datasets[0];
            // Calculate CAGR
            let dataPoints = pcd.data.datasets[0].data.length;
            let increment = (pcd.data.datasets[0].data[dataPoints - 1] - pcd.data.datasets[0].data[0]) / (dataPoints - 1);
            let cagr = [];
            for (let i = 0; i < dataPoints; i++) {
                cagr[i] = i === 0 ? parseFloat(pcd.data.datasets[0].data[i]) : cagr[i - 1] + increment;
            }
            
            // Set CAGR Line chart
            pcd.data.datasets[0] = {
                data: cagr,
                type: 'line',
                borderColor: '#000',
                borderOpacity: 1,
                rotate: 0.5,
                pointRadius: 0
            };
            
            // Define slope
            let slope;
            
            pcd.data.datasets[0].datalabels = {
                display: true,
                align: 'center',
                padding: {
                    top: 5,
                    right: 10,
                    bottom: 5,
                    left: 10
                },
                borderRadius: 10,
                font: {
                    family: settings.font_family,
                },
                rotation: function(context) {
                    var dataset = context.dataset;
                    if (dataset.rotate !== undefined) {
                        return dataset.rotate;
                    }
                    return 0;
                },
                formatter: function(value, context) {
                    if (context.dataIndex === Math.floor(context.dataset.data.length / 2)) {
                        // Calculate the number of periods (n) correctly as one less than the number of data points
                        let periods = context.dataset.data.length - 1;
                
                        // Calculate CAGR value
                        let cagrValue = (Math.pow((context.dataset.data[periods] / context.dataset.data[0]), (1 / periods)) - 1) * 100;
                
                        // Check if CAGR value is an integer or has a decimal
                        const isInteger = cagrValue % 1 === 0;
                
                        // Format CAGR value based on whether it is an integer
                        const formattedCagrValue = isInteger ? cagrValue.toFixed(0) : cagrValue.toFixed(2);
                
                        return formattedCagrValue + "% CAGR";
                    } else {
                        return null;
                    }
                },
                backgroundColor: function(context) {
                    if (context.dataIndex === Math.floor(context.dataset.data.length / 2)) {
                        return '#80BBBF'; // CAGR Background Color
                    } else {
                        return 'transparent';
                    }
                },
                borderColor: function(context) {
                    if (context.dataIndex === Math.floor(context.dataset.data.length / 2)) {
                        return '#80BBBF'; // CAGR Border Color
                    } else {
                        return 'transparent';
                    }
                },
                color: function(context) {
                    if (context.dataIndex === Math.floor(context.dataset.data.length / 2)) {
                        return '#555555'; // CAGR Text Color
                    } else {
                        return 'transparent';
                    }
                }                
            }
            pcd.data.datasets[1].datalabels = {
                display: false
            }
            
        } else {
            // Data Labels Plugin
            pcd.options.layout = {
                padding: {
                    top: 20,
                    right: 40
                }
            }
        }
    } else {
        pcd.options.plugins.datalabels = {
            display: false
        }
        pcd.options.pointRadius = settings.pointRadius;
        pcd.options.pointBorderWidth = settings.pointBorderWidth;
        pcd.options.pointHoverRadius = settings.pointRadius + 5;
        pcd.options.cubicInterpolationMode = settings.cubicInterpolationMode;
        if (!cd.hide_legend_table) {
            pcd.plugins = [htmlLegendPlugin];
            pcd.options.plugins.htmlLegend = {
                containerID: `chart-${cd.row_id}-${cd.id}-legend`,
                type: legend_wrapper_type
            }
        }
    }
    /*
    pcd.options.scales.y.ticks.callback = (value, index, values) => {
        let baseNum;
    
        // Determine the base number based on conditions
        if (value === 0) {
            baseNum = '0';
        } else if (cd.unit === 'million' && value >= 1000) {
            // Check if the result is an integer and format accordingly
            baseNum = (value / 1000) % 1 === 0 ? (value / 1000).toFixed(0) : (value / 1000).toFixed(1);
        } else if (cd.unit === 'billion' && value < 1) {
            baseNum = (value * 1000).toFixed(0);
        } else if (settings.abbreviateNumber && !cd.custom_unit) {
            baseNum = abbreviateNumber(value);
        } else {
            baseNum = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
    
        // Early return for special units: currency or percentage
        if (cd.unit == 'currency') {
            if (cd.hide_x_axis_unit == 1) {
                return baseNum;
            } else {
                return '$' + baseNum;
            }
        } else if (cd.unit == 'percentage') {
            if (cd.hide_x_axis_unit == 1) {
                return baseNum;
            } else {
                return baseNum + '%';
            }
        } else if  (cd.custom_unit) {
            if (cd.hide_x_axis_unit == 1) {
                return baseNum;
            } else {
                return baseNum + cd.custom_unit;
            }
        }
    
        // Check if x-axis unit should be hidden
        if (cd.hide_x_axis_unit == 1) {
            return baseNum;
        }
    
        // Determine the suffix based on the unit and conditions
        let suffix = '';
        if (value !== 0) { // Avoid appending suffix for 0 value
            if (cd.unit === 'million' && value >= 1000) {
                suffix = 'B';
            } else if (cd.unit === 'billion' && value < 1) {
                suffix = 'M';
            } else if (cd.unit === 'million') {
                suffix = 'M';
            } else if (cd.unit === 'billion') {
                suffix = 'B';
            }
        }
    
        // Return the base number with the appropriate suffix
        return baseNum + suffix;
    };
    */
    // Setup stacked bars
    pcd.options.scales.x.stacked = cd.stacked == 1;
    pcd.options.scales.y.stacked = cd.stacked == 1;
    
    return pcd;
}

document.addEventListener("DOMContentLoaded", (event) => {
    let chart_groups = [];
    document.querySelectorAll('.module-charts').forEach((chart_group, index) => {
        let data = JSON.parse(document.getElementById(`charts-data-${chart_group.dataset.row}`).innerText);
        chart_groups.push(data);
        chart_groups[index].id = chart_group.dataset.row;
    });
    // Register data labels plugin
    Chart.register(ChartDataLabels);
    
    chart_groups.forEach((charts_data) => {
        let row_id = charts_data.id;
        charts_data.all_data.forEach((cd) => {
            cd.row_id = row_id;
            let el = document.getElementById(`chart-${row_id}-${cd.id}`);
            let chart_config = prep_config(cd);
            
            if (el) {
                // Determine height based on chart type if cd.chart_height is not specified
                let chart_height = cd.chart_height;
                if (!chart_height) {
                    switch (cd.type) {
                        case 'pie':
                        case 'doughnut':
                            chart_height = 270;
                            break;
                        case 'bar':
                            chart_height = 340;
                            break;
                        case 'line':
                            chart_height = 600;
                            break;
                        default:
                            chart_height = 600;
                    }
                }
                
                // Set the height of the canvas element
                el.height = chart_height;
                
                // Create the chart
                let myChart = new Chart(el, chart_config);
                
                // Rotate label if has CAGR Label
                let first_dataset = chart_config.data.datasets[0];
                if (cd.cagr) {
                    setTimeout(function() {
                        let dataPoints = first_dataset.data.length;
                        slope = (myChart.getDatasetMeta(0).data[dataPoints - 1].y - myChart.getDatasetMeta(0).data[0].y) / (myChart.getDatasetMeta(0).data[dataPoints - 1].x - myChart.getDatasetMeta(0).data[0].x);
                        let angle = Math.atan(slope) * (180 / Math.PI);
                        chart_config.data.datasets[0].datalabels.rotation = angle;
                        myChart.update();
                    }, 500);
                }
            }
        });
    });
});

// Function to abbreviate a number to its power of 10's suffix
function abbreviateNumber(number) {
    const SI_SYMBOL = ["", "K", "M", "B", "t", "q", "Q"];
    let tier = Math.log10(Math.abs(number)) / 3 | 0;
    
    if (tier === 0) {
        return number;
    }
    
    let suffix = SI_SYMBOL[tier];
    let scale = Math.pow(10, tier * 3);
    let scaled = number / scale;
    
    return scaled.toFixed(0) + suffix;
}